import { overviewSchema, type MetricPeriod, type Overview } from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export function fetchOverview(
  period: MetricPeriod,
  options: { refresh?: boolean; signal?: AbortSignal } = {},
): Promise<Overview> {
  const query = new URLSearchParams({ period })
  if (options.refresh) query.set('refresh', 'true')

  return apiRequest(`/metrics/overview?${query.toString()}`, { schema: overviewSchema, signal: options.signal })
}
